<template>
	<div class="table">
		<el-table
			:stripe="true" :border="true"
		    :data="TableQuery.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
		  style="width: 100%"
		>
		  <el-table-column label="报表名称" prop="name" width='120'> </el-table-column>
		  <el-table-column label="部门" prop="obj" width='120'> </el-table-column>
			<!-- <el-table-column label="现对名称" prop="nowtit"> </el-table-column> -->
			<el-table-column label="1月" prop="type" width='120'> </el-table-column>
			<el-table-column label="2月" prop="describe" width='120'> </el-table-column>
			<el-table-column label="3月" prop="leader" width='120'> </el-table-column>
			<el-table-column label="4月" prop="state" width='120'></el-table-column>
    		<el-table-column label="5月" prop="type" width='120'> </el-table-column>
			<el-table-column label="6月" prop="describe" width='120'> </el-table-column>
			<el-table-column label="7月" prop="leader" width='120'> </el-table-column>
			<el-table-column label="8月" prop="state" width='120'></el-table-column>
		  <el-table-column align="right" width='180'>
		    <template #header>
		      <el-input v-model="search" size="mini" placeholder="输入关键字搜索" />
		    </template>
		    <template #default="scope">
		      <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
		        >编辑</el-button>
		      <el-button
		        size="mini"
		        type="danger"
		        @click="handleDelete(scope.$index, scope.row)"
		        >删除</el-button>
		    </template>
			
		  </el-table-column>  
		</el-table>
		<!-- 编辑模态框 -->
		<el-drawer
		  title="编辑内容"
		  :visible.sync="drawer"
		  :direction="direction"
		  :before-close="handleClose">
		  <!-- 卡片 -->
		  <el-card class="box-card">
			<p>{{ '名称：' + edtable.name }}</p>
			<p>{{ '对象：' + edtable.obj }}</p>
			<p>{{ '类型：' + edtable.type }}</p>
			<p>{{ '描述：' + edtable.describe }}</p>
			<!-- 状态 -->
			<p>
				<span>{{ '状态：' + edtable.state }}</span>
				<!-- <el-button style="margin-top: 12px;" size="mini" @click="next()">下一步</el-button> -->
			</p>
			<p>{{ '负责人：' + edtable.leader }}</p>
			<p>{{ '地址：' + edtable.address }}</p>
			<p>{{ '负责人：' + edtable.leader }}</p>
		  </el-card>
		  
		</el-drawer>
	</div>
</template>

<script>
	// selfs / js
	import TableQuery from '../../external/comment/TableQuery.js'
	  export default {
		data() {
		  return {
			drawer: false,
			active: 0,
			direction: 'rtl',
			TableQuery: [],
			edtable: [],
			search: '',
			edindex:0,
		  }
		},		
		mounted() {
			// 模拟信息
			this.TableQuery = TableQuery.map(function(v) {
				return v
			})
		},
		methods: {
			// 步骤
			next() {
				this.active ++
				if (this.active ++ > 2) this.active = 0;
			  },
			handleEdit(index, row) {
			 this.drawer = !this.drawer
			 this.edindex = row.index
			 this.edtable = row
			  // console.log(this.edtable)
		   },
		   handleClose(done) {
			   this.$confirm('确认关闭？')
				 .then(_ => {
				   done();
				 })
				 .catch(_ => {});
			 },
			handleDelete(index, row) {
			 console.log(index, row)
		   },
		}
		
	  }
</script>

<style lang="less" scoped>
.table{
	margin-top: 12px;
	font-size: 12px;
	
	/* 穿透 */
	/deep/ .el-table td.el-table__cell div{
		display: flex !important;
		justify-content: center;
		align-items: center;
		font-size: 12px;
	}
	/deep/ .el-table--border .el-table__cell {
		text-align: center !important;
	}
}
</style>
